export default "__VITE_ASSET__cOrbFikU__"